// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__1OD74","card":"Cards_card__2zZAL","infected":"Cards_infected__2Q4CF","recovered":"Cards_recovered__msl4U","deaths":"Cards_deaths__1Sq5S"};